import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import {
  type FrontendOnlyColumn,
  type GraphPath,
  createTopologyGraphLink,
} from '@ipfabric/utils';
import { Button } from 'components/Button/Button';
import { navigateGraphToLocation } from 'components/Graph/helpers/graphLink';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import { DownloadSiteReport } from 'containers/DownloadSiteReport/DownloadSiteReport';

type Row = {
  siteName: GraphPath;
};

export const inventorySitesActionsColumn: FrontendOnlyColumn<Row> =
  createFrontendOnlyColumn<Row>({
    key: 'actions',
    title: 'Actions',
    webDependencies: ['siteName'],
    disabledSort: true,
    width: 117,
    fixedWidth: true,
    render: (
      row,
      {
        locale: {
          apiTable: {
            tables: {
              inventory: {
                sites: { actions: actionsMsg },
              },
            },
          },
        },
        ...context
      },
    ) => (
      <>
        <Tooltip content={actionsMsg.showDevices}>
          <Button
            variant='tertiary'
            icon='fa-box-archive'
            iconStyle='regular'
            className='mr-2'
            type='button'
            onClick={() => {
              context.navigate(
                `/inventory/devices?options=${encodeURIComponent(
                  JSON.stringify({
                    filters: { siteName: ['eq', row.siteName] },
                  }),
                )}&tmp=1`,
              );
            }}
            size='xxs'
          />
        </Tooltip>
        <Tooltip content={actionsMsg.showDiagram}>
          <Button
            variant='tertiary'
            icon='fa-chart-network'
            className='mr-2'
            type='button'
            onClick={() => {
              context.navigate(
                ...navigateGraphToLocation(
                  createTopologyGraphLink({
                    parameters: { paths: [row.siteName], groupBy: 'siteName' },
                  }),
                ),
              );
            }}
            size='xxs'
          />
        </Tooltip>
        <Tooltip content={actionsMsg.downloadReport}>
          <DownloadSiteReport
            hideText
            variant='tertiary'
            siteName={row.siteName}
            size='xxs'
          />
        </Tooltip>
      </>
    ),
  });
